/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Модель для товара допродажи в корзине
   */
  app.UpsaleItem = app.Model.extend({
    url: function () {
      var currentCurrency = this.get('currency');
      var currencyParam = currentCurrency ? '?currency=' + currentCurrency : '';
      return app.entryScriptName + '/api/v3/item/upsale/' + currencyParam;
    },
  });
})(jQuery);

}.call(window));